<template>
  <div class="main">
    <div class="nav">
      <ul>
        <li v-for="(item,index) in nav" :key="index" @click="changeNews(item,index)">{{item.title}}</li>
      </ul>
      <div :style="`left:calc((100% - ${1.3*nav.length-2.6*currentIndex}rem)/2)`" class="navLine"></div>
    </div>
    <div class="line"></div>
    <div class="content">
      <transition mode="out-in">
        <router-view></router-view>
      </transition>
    </div>
  </div>
</template>
<script>
import Bus from "@/utils/bus.js";
export default {
  data() {
    return {
      currentIndex: 0
    };
  },
  props: {
    nav: {
      type: null
    }
  },
  mounted() {
    this.changeIndex();
    // Bus.$on("changeIndex", e => {
    //   this.changeIndex();
    // });
  },
  methods: {
    changeNews(item, index) {
      this.currentIndex = index;
      this.$router.push({ name: item.url });
    },
    changeIndex() {
      this.nav.forEach((item, index) => {
        if (
          item.url ==
          window.location.hash.substring(2, window.location.hash.length)
        ) {
          this.currentIndex = index;
        }
      });
    }
  },
  components: {}
};
</script>

<style lang="less" scoped>
@color: #ff7234;
.main {
  width: 100%;
  .nav {
    height: 60px;
    position: relative;
    ul {
      display: flex;
      height: 60px;
      justify-content: center;
      li {
        font-size: 15px;
        width: 70px;
        height: 60px;
        text-align: center;
        margin-right: 60px;
        margin-bottom: 5px;
        position: relative;
        line-height: 60px;
        cursor: pointer;
      }
    }
    .navLine {
      width: 70px;
      height: 4px;
      background-color: #ff7234;
      position: absolute;
      transition: 0.3s all linear;
      bottom: 0px;
    }
  }
  .line {
    width: 100%;
    height: 1px;
    background-color: #e6e6e6;
  }
  .content {
    width: 810px;
    margin: 0px auto;
    .v-enter {
      opacity: 0;
    }
    .v-enter-active {
      transition: 0.5s;
    }
    .v-enter-to {
      opacity: 1;
    }
    .v-leave {
      opacity: 1;
    }
    .v-leave-to {
      opacity: 0;
    }
    .v-leave-active {
      transition: 0.5s;
    }
  }
}
</style>